import React, { useEffect, useState } from 'react';
import ProtectedLDWrapper from './components/Protected';
import ErrorPage from './components/ErrorPage';

function App() {
  const searchParams = new URLSearchParams(window.location.search);
  const urlError = searchParams.get('error');

  const [userLocation, setUserLocation] = useState({});

  useEffect(() => {
    function requestUserLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(showPosition, handleError);
      } else {
        console.error('Geolocation is not supported by this browser.');
      }
    }

    function showPosition(position) {
      console.debug('retrieved user location');
      setUserLocation({
        latitude: position.coords.latitude,
        longitude: position.coords.longitude,
      });
    }

    function handleError(error) {
      switch (error.code) {
        case error.PERMISSION_DENIED:
          console.debug('User denied the request for Geolocation.');
          break;
        case error.POSITION_UNAVAILABLE:
          console.debug('Location information is unavailable.');
          break;
        case error.TIMEOUT:
          console.debug('The request to get user location timed out.');
          break;
        case error.UNKNOWN_ERROR:
          console.debug('An unknown error occurred.');
          break;
      }
    }
    requestUserLocation();
  }, []);

  if (urlError) {
    // Render the Error Page if error query parameter is present
    return <ErrorPage error={urlError} />;
  }

  // Render the Protected components otherwise
  return <ProtectedLDWrapper userLocation={userLocation} />;
}

export default App;
